"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrentNotificationTokenFromState = void 0;
var getCurrentNotificationTokenFromState = function (_a) {
    var _b, _c;
    var state = _a.state;
    var notificationToken = (_c = (_b = state.currentUnscopeUser) === null || _b === void 0 ? void 0 : _b.notificationTokens) === null || _c === void 0 ? void 0 : _c.find(function (_a) {
        var _b, _c;
        var token = _a.token, fingerPrint = _a.fingerPrint;
        return (token === ((_b = state.windowMeta) === null || _b === void 0 ? void 0 : _b.firebaseMessagingToken) ||
            fingerPrint === ((_c = state.windowMeta) === null || _c === void 0 ? void 0 : _c.fingerPrint));
    });
    return notificationToken;
};
exports.getCurrentNotificationTokenFromState = getCurrentNotificationTokenFromState;
